// extracted by mini-css-extract-plugin
export var button = "_cg-4";
export var hasDarkBackground = "_cg-7";
export var hasLightBackground = "_cg-6";
export var iconWrapper = "_cg-0";
export var large = "_cg-2";
export var medium = "_cg-1";
export var small = "_cg-5";
export var xsmall = "_cg-3";